// extracted by mini-css-extract-plugin
export default {"desktop":"style_desktop__TE2Si","mobile":"style_mobile__K4Un2","laptop":"style_laptop__fMEL-","v3":"style_v3__s9ej-"};